document.addEventListener('DOMContentLoaded', async () => {
  // Define B2B collections
  const b2bCollections = [
    '/collections/wholesale-collection',
    '/collections/b2b-1',
    '/collections/hrc-2',
    '/collections/hrc-1'
  ];

  // Check if on a B2B collection page
  const isB2BCollection = b2bCollections.some(collection => window.location.pathname.includes(collection));
  if (!isB2BCollection) return;

  // Fetch logged-in customer data via Storefront API
  try {
    const response = await fetch('/api/2025-04/customers/me.json', {
      headers: { 'X-Shopify-Storefront-Access-Token': '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' }
    });
    if (!response.ok) return; // No logged-in customer or API error
    const customer = await response.json();

    // Get customer tags
    const tags = customer?.tags || [];
    let priceTier = null;
    if (tags.includes('B2B 1')) priceTier = 'Wholesale - B2B 1';
    else if (tags.includes('Wholesale')) priceTier = 'Wholesale - B2B 2';
    else if (tags.includes('HRC 1')) priceTier = 'HRC 1';
    else if (tags.includes('HRC 2')) priceTier = 'HRC 2';

    if (!priceTier) return; // Non-B2B customer, show default price

    // Update product prices on page
    document.querySelectorAll('.product-price').forEach(element => {
      const productHandle = element.dataset.productHandle;
      if (!productHandle) return;

      // Fetch product metafield (b2b_pricing.price_tiers)
      fetch(`/products/${productHandle}.js`)
        .then(res => res.json())
        .then(product => {
          const priceTiers = product.metafields?.find(m => m.namespace === 'b2b_pricing' && m.key === 'price_tiers')?.value;
          if (priceTiers) {
            const tiers = JSON.parse(priceTiers);
            const price = tiers[priceTier];
            if (price) {
              element.textContent = `£${price.toFixed(2)}`;
            }
          }
        })
        .catch(err => console.error('Error fetching product:', err));
    });
  } catch (err) {
    console.error('Error fetching customer:', err);
  }
});